import { useEffect, useRef } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { usePerson } from '../contexts/PersonContext'

/** Keep delayed UI receipts and redirects inside the profile/route that initiated them. */
export function useActionBoundary(scope = '') {
  const { getSessionGeneration } = useAuth()
  const { activePerson } = usePerson()
  const identity = `${scope}:${activePerson?.id ?? ''}:${sessionStorage.getItem('cot_jwt_token') ?? ''}`
  const current = useRef({ identity, generation: 0 })
  if (current.current.identity !== identity) current.current = { identity, generation: current.current.generation + 1 }
  const mounted = useRef(true)
  useEffect(() => { mounted.current = true; return () => { mounted.current = false } }, [])
  return () => {
    const started = current.current.generation
    const session = getSessionGeneration()
    const token = sessionStorage.getItem('cot_jwt_token')
    return () => mounted.current && current.current.generation === started && getSessionGeneration() === session && sessionStorage.getItem('cot_jwt_token') === token
  }
}
